import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";

export function useExportJobTrackerAllJobs() {
  return useMutation({
    mutationFn: async () => {
      await guacHttpClient.post("exports/job-tracker-all-jobs");
    },
  });
}
